
import { defineComponent, onMounted, ref } from "vue";
import KTDrawerMessenger from "@/layout/extras/MessengerDrawer.vue";
import MerchantAlert from "@/components/modals/general/MerchantAlert.vue";

export default defineComponent({
  components: {
    KTDrawerMessenger,
    MerchantAlert,
  },
  setup() {
    const parentBorder = ref(false);
    const childBorder = ref(false);
    const tableData = [
      {
        date: "2016-05-03",
        name: "197.187.84.52",
        state: "California",
        city: "San Francisco",
        address: "3650 21st St, San Francisco",
        zip: "CA 94114",
        risk: "78%",
        family: [
          {
            name: "Jerry",
            state: "California",
            city: "San Francisco",
            address: "3650 21st St, San Francisco",
            zip: "CA 94114",
            bank: "Bank Of America",
            reason: "Address Verification",
          },
        ],
      },
      {
        date: "2016-05-02",
        name: "207.45.454.18",
        state: "California",
        city: "San Francisco",
        address: "3650 21st St, San Francisco",
        zip: "CA 94114",
        risk: "59%",

        family: [
          {
            name: "Jerry",
            state: "California",
            city: "San Francisco",
            address: "3650 21st St, San Francisco",
            zip: "CA 94114",
          },
          {
            name: "Spike",
            state: "California",
            city: "San Francisco",
            address: "3650 21st St, San Francisco",
            zip: "CA 94114",
          },
        ],
      },
      {
        date: "2016-05-04",
        name: "1.422.10.110.1",
        state: "California",
        city: "San Francisco",
        address: "3650 21st St, San Francisco",
        zip: "CA 94114",
        risk: "87%",

        family: [
          {
            name: "Jerry",
            state: "California",
            city: "San Francisco",
            address: "3650 21st St, San Francisco",
            zip: "CA 94114",
          },
          {
            name: "Spike",
            state: "California",
            city: "San Francisco",
            address: "3650 21st St, San Francisco",
            zip: "CA 94114",
          },
        ],
      },
      {
        date: "2016-05-01",
        name: "84.52.197.187",
        state: "California",
        city: "San Francisco",
        address: "3650 21st St, San Francisco",
        zip: "CA 94114",
        risk: "47%",

        family: [
          {
            name: "Jerry",
            state: "California",
            city: "San Francisco",
            address: "3650 21st St, San Francisco",
            zip: "CA 94114",
          },
          {
            name: "Spike",
            state: "California",
            city: "San Francisco",
            address: "3650 21st St, San Francisco",
            zip: "CA 94114",
          },
        ],
      },
      {
        date: "2016-05-08",
        name: "187.84.197.52",
        state: "California",
        city: "San Francisco",
        address: "3650 21st St, San Francisco",
        zip: "CA 94114",
        risk: "87%",

        family: [
          {
            name: "Jerry",
            state: "California",
            city: "San Francisco",
            address: "3650 21st St, San Francisco",
            zip: "CA 94114",
          },
          {
            name: "Spike",
            state: "California",
            city: "San Francisco",
            address: "3650 21st St, San Francisco",
            zip: "CA 94114",
          },
        ],
      },
      {
        date: "2016-05-06",
        name: "197.187.84.52",
        state: "California",
        city: "San Francisco",
        address: "3650 21st St, San Francisco",
        zip: "CA 94114",
        risk: "77%",

        family: [
          {
            name: "Jerry",
            state: "California",
            city: "San Francisco",
            address: "3650 21st St, San Francisco",
            zip: "CA 94114",
          },
          {
            name: "Spike",
            state: "California",
            city: "San Francisco",
            address: "3650 21st St, San Francisco",
            zip: "CA 94114",
          },
        ],
      },
      {
        date: "2016-05-07",
        name: "197.187.84.52",
        state: "California",
        city: "San Francisco",
        address: "3650 21st St, San Francisco",
        zip: "CA 94114",
        risk: "69%",

        family: [
          {
            name: "Jerry",
            state: "California",
            city: "San Francisco",
            address: "3650 21st St, San Francisco",
            zip: "CA 94114",
          },
          {
            name: "Spike",
            state: "California",
            city: "San Francisco",
            address: "3650 21st St, San Francisco",
            zip: "CA 94114",
          },
        ],
      },
    ];
    return {
      tableData,
      parentBorder,
      childBorder,
    };
  },
});
